(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pq-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!window.pqProductShelfHoverVideoReady) {
    window.pqProductShelfHoverVideoReady = true;

    document.addEventListener('mouseover', function (event) {
      const media = event.target.closest('.pq-product-shelf__media');
      if (!media || (event.relatedTarget && media.contains(event.relatedTarget))) return;

      const video = media.querySelector('.pq-product-shelf__video');
      if (video) video.play().catch(function () {});
    });

    document.addEventListener('mouseout', function (event) {
      const media = event.target.closest('.pq-product-shelf__media');
      if (!media || (event.relatedTarget && media.contains(event.relatedTarget))) return;

      const video = media.querySelector('.pq-product-shelf__video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
